export const queryKeys = {
  PAYMENT: 'PAYMENT',
  CONTRACT_DATA_FOR_CREATE_PAYMENT: 'CONTRACT_DATA_FOR_CREATE_PAYMENT'
};
